import { Space, Tag } from 'antd';
import type { BrandCategory, SecurityRequestType } from '@wisecure/api-client';
import { CATEGORY_COLORS, CATEGORY_LABELS, REQUEST_TYPE_COLORS, REQUEST_TYPE_LABELS } from './labels';

export function CategoryTags({ categories }: { categories: BrandCategory[] }) {
  if (!categories.length) return <>—</>;
  return (
    <Space size={[4, 4]} wrap>
      {categories.map((category) => (
        <Tag key={category} color={CATEGORY_COLORS[category]} style={{ marginInlineEnd: 0 }}>
          {CATEGORY_LABELS[category] ?? category}
        </Tag>
      ))}
    </Space>
  );
}

export function RequestTypeTag({ type }: { type: SecurityRequestType }) {
  return <Tag color={REQUEST_TYPE_COLORS[type]}>{REQUEST_TYPE_LABELS[type] ?? type}</Tag>;
}
